<div class="sidebar">
  <hb-sidebar-header></hb-sidebar-header>
  <hb-sidebar-form></hb-sidebar-form>
  <nav class="sidebar-nav">
    <ul class="nav" (click)="onNavItemClick()" (contextmenu)="onNavItemClick()">
      <li class="nav-item" *ngIf="!isError">
        <a class="nav-link cap" routerLinkActive="active" [routerLink]="dashboardURL" id="dashboard">
          <i class="fa fa-tachometer-alt" aria-hidden="true"></i>
          <span class="menufix">{{ 'Sidebar.Dashboard' | i18next }}</span>
        </a>
      </li>

      <!-- Asset Management menu -->
      <hb-sub-menu
        [showSubMenu]="hasHierarchyReadAccess || hasReportsAllReadAccess"
        subMenuTitle="{{ 'Sidebar.ManageEquipment' | i18next }}"
        [menuItems]="manageEquipmentMenuItems"
        [isSubMenuActive]="amItemActive()"
        iconClass="fa fa-sitemap"
        navMenuId="manage-equipment"
      ></hb-sub-menu>

      <!-- RBI menu -->
      <hb-sub-menu
        [showSubMenu]="
          hasRbiRiskAnalysisModelRunReadAccess ||
          rbiRiskAnalysisMassCriticalityRead ||
          hasRbiMitigationsRecommentationReadAccess ||
          rbiRiskAnalysisMassCriticalityTemplatesRead
        "
        subMenuTitle="{{ 'Sidebar.RBI' | i18next }}"
        [menuItems]="rbiMenuItems"
        [isSubMenuActive]="rbiItemActive()"
        iconClass="fa fa-th"
        navMenuId="rbi"
      ></hb-sub-menu>

      <!-- Maintenance menu -->
      <hb-sub-menu
        [showSubMenu]="
          hasMaintenanceMaintenanceStrategyReadAccess || hasMaintenanceMaintenanceOptimizationReadAccess
        "
        subMenuTitle="{{ 'Sidebar.Maintenance' | i18next }}"
        [menuItems]="maintenanceMenuItems"
        [isSubMenuActive]="maintenanceItemActive()"
        iconClass="fa fa-wrench"
        navMenuId="maintenance"
      ></hb-sub-menu>

      <!-- IDMS menu -->
      <hb-sub-menu
        [showSubMenu]="hasIdmsInspectionReportReadAccess || hasIdmsThicknessLocationReadAccess || hasIdmsThicknessReportRead"
        subMenuTitle="{{ 'Sidebar.IDMS' | i18next }}"
        [menuItems]="idmsMenuItems"
        [isSubMenuActive]="idmsItemActive()"
        iconClass="fa fa-list-ul"
        navMenuId="idms"
      ></hb-sub-menu>

      <!-- Build menu -->
      <hb-sub-menu
        [showSubMenu]="hasBuildModelReadAccess || hasBuildFunctionReadAccess || hasBuildLookupReadAccess"
        subMenuTitle="{{ 'Sidebar.Build' | i18next }}"
        [menuItems]="buildMenuItems"
        [isSubMenuActive]="buildItemActive()"
        iconClass="fa fa-cube"
        navMenuId="build"
      ></hb-sub-menu>

      <!-- Admin menu -->
      <hb-sub-menu
        hbMenuViewportRestrict
        [showSubMenu]="
          hasAdminOrganisationReadAccess ||
          hasAdminModelReadAccess ||
          hasAdminRiskMatrixReadAccess ||
          hasAdminHierarchyTemplateReadAccess ||
          hasAdminInspectionTemplateReadAccess ||
          hasAdminEventTemplateReadAccess ||
          hasAdminLookupReadAccess ||
          hasAdminMasterInspectionMethodReadAccess ||
          hasAdminUomReadAccess ||
          hasAdminMasterAttributeReadAccess ||
          hasAdminMaintenanceReadAccess ||
          hasAdminModelManagerViewAccess ||
          hasAdminDataUploadExecute ||
          hasAdminUpdateOperationsReadAccess
        "
        subMenuTitle="{{ 'Sidebar.Admin' | i18next }}"
        [menuItems]="adminMenuItems"
        [isSubMenuActive]="adminItemActive()"
        iconClass="fa fa-cog"
        navMenuId="admin"
      ></hb-sub-menu>

      <!-- Security menu -->
      <hb-sub-menu
        navMenuId="security"
        [showSubMenu]="hasIsSecurityAccess"
        hbMenuViewportRestrict
        subMenuTitle="{{ 'Sidebar.Security' | i18next }}"
        [menuItems]="securityMenuItems"
        [isSubMenuActive]="securityItemActive()"
        iconClass="fa fa-lock"
        (openPopupClicked)="onopenPopupClicked($event)"
      ></hb-sub-menu>

      <!-- User menu -->
      <li class="nav-item" *ngIf="userAuthenticated" hbMenuViewportRestrict>
        <a class="nav-menu-item" id="account">
          <i class="fa fa-user-circle"></i>
        </a>
        <ul class="nav-sub-menu">
          <li>
            <div class="sub-menu-title-container">
              <p class="sub-menu-title">{{ 'Sidebar.Account' | i18next }}</p>
            </div>
          </li>
          <li class="hide-item">
            <div class="user-name-container">
              <span align="center">{{ loggedInUser }}</span>
            </div>
            <div class="spacer"></div>
          </li>
          <li class="nav-sub-menu-item" [ngClass]="{ 'hide-item': usingLoginProvider }">
            <a class="nav-link" (click)="resetPassword()" tabindex="0">
              <i class="fa fa-square" id="account-reset-password"></i> {{ 'Sidebar.ResetPassword' | i18next }}
            </a>
          </li>
          <li class="nav-sub-menu-item">
            <a class="nav-link" (click)="logout()" tabindex="0" id="account-sign-out">
              <i class="fa fa-square"></i> {{ 'Sidebar.SignOut' | i18next }}
            </a>
          </li>
        </ul>
      </li>

      <li *ngIf="hasLicenseViewAccess" class="nav-item cap">
        <hb-licensing></hb-licensing>
      </li>
    </ul>
  </nav>
  <hb-sidebar-footer></hb-sidebar-footer>
</div>
